import React from 'react';
import { Space, Progress, Tag, Typography, Button, Divider } from 'antd';
import { ArrowLeftOutlined, InboxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useReceiptPutaway } from '@contexts/operator/ReceiptPutawayContext';
import { RECEIPT_STATUS_COLORS } from '@constants/receipts';

const { Text, Title } = Typography;

export default function PutawayHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, derived } = useReceiptPutaway();
  const r = state.receipt;
  if (!r) return null;

  const pct = derived.totalReceivedQty > 0
    ? Math.round((derived.totalPutawayQty / derived.totalReceivedQty) * 100)
    : 0;

  return (
    <div style={{
      padding: '16px 24px 12px',
      borderBottom: '1px solid #f0f0f0',
      background: '#fff',
    }}>
      {/* Row 1: back + title + status + context */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(`/inbounds/${r.inbound_id}`)}
        >
          {t('common.button.back')}
        </Button>

        <Divider type="vertical" style={{ height: 24, margin: 0 }} />

        <Title level={4} style={{ margin: 0, fontSize: 18, lineHeight: '24px' }}>
          {r.inbound_name}
        </Title>
        <Text type="secondary" style={{ fontSize: 14 }}>/</Text>
        <Title level={4} style={{ margin: 0, fontSize: 18, lineHeight: '24px', color: '#1677ff' }}>
          {r.name}
        </Title>
        <Tag color={RECEIPT_STATUS_COLORS[r.status] || 'default'}>
          {t(`enums.receipt.status.${r.status}`, { defaultValue: r.status })}
        </Tag>

        <div style={{ marginLeft: 'auto' }}>
          <Space size="small" split={<Divider type="vertical" />}>
            <Text type="secondary">{r.warehouse?.name}</Text>
            <Text type="secondary">{r.merchant_name}</Text>
          </Space>
        </div>
      </div>

      {/* Row 2: staging dock + progress */}
      <div style={{
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 24,
      }}>
        <Space size={6}>
          <InboxOutlined style={{ color: '#8c8c8c' }} />
          <Text type="secondary" style={{ fontSize: 13 }}>
            {t('operator.pages.putaway.header.staging_dock')}
          </Text>
          <Text strong style={{ fontSize: 13 }}>
            {r.staging_shelf?.location || '—'}
          </Text>
        </Space>

        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 12 }}>
          <Text type="secondary" style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
            {t('operator.pages.putaway.header.progress')}
          </Text>
          <Text strong style={{ fontSize: 13, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
            {derived.totalPutawayQty} / {derived.totalReceivedQty}
          </Text>
          <Progress
            percent={pct}
            size="small"
            style={{ flex: 1, maxWidth: 360, margin: 0 }}
            strokeColor={pct === 100 ? '#52c41a' : '#1677ff'}
          />
        </div>
      </div>
    </div>
  );
}
